import React from 'react';
import ClinicalButton from '../../doctor/ui/ClinicalButton';
import { NURSE_COPY } from '../nurseCopy';
import {
  NURSE_PASSAGE_SECTION_ORDER,
  getPassageSectionLabel
} from './nursePassageSections';

export { NURSE_PASSAGE_SECTION_ORDER as NURSE_PASSAGE_STEP_ORDER } from './nursePassageSections';

const W = NURSE_COPY.WORKSPACE;
const FOOTER_BTN = 'nr-passage-footer__btn';

function FooterLabel({ long, short }) {
  return (
    <>
      <span className="nr-passage-footer__label nr-passage-footer__label--long">{long}</span>
      <span className="nr-passage-footer__label nr-passage-footer__label--short">{short}</span>
    </>
  );
}

export default function NursePassageFooter({
  activeStep,
  onPrev,
  onNext,
  disableNext = false,
  passageClosed = false,
  busyAction = false,
  consultation,
  onTransfer,
  onClose
}) {
  const index = NURSE_PASSAGE_SECTION_ORDER.indexOf(activeStep);
  const safeIndex = index >= 0 ? index : 0;
  const isFirst = safeIndex <= 0;
  const isLast = safeIndex >= NURSE_PASSAGE_SECTION_ORDER.length - 1;
  const sectionLabel = getPassageSectionLabel(activeStep);

  return (
    <footer className="nr-passage-footer nr-no-print" aria-label={W.FOOTER_ARIA}>
      <div className="nr-passage-footer__inner">
        {passageClosed ? (
          <p className="nr-passage-footer__closed-msg mb-0">{W.CLOSE_ALREADY}</p>
        ) : (
          <div className="nr-passage-footer__toolbar" role="group" aria-label={W.FOOTER_ARIA}>
              <ClinicalButton
                className={FOOTER_BTN}
                variant="secondary"
                size="md"
                icon="chevronLeft"
                onClick={onPrev}
                disabled={isFirst}
              >
                <FooterLabel long={W.NAV_PREV} short={W.NAV_PREV_SHORT} />
              </ClinicalButton>

              {sectionLabel ? (
                <span className="nr-passage-footer__section" aria-live="polite">
                  {sectionLabel}
                </span>
              ) : null}

              {!isLast ? (
                <ClinicalButton
                  className={FOOTER_BTN}
                  variant="secondary"
                  size="md"
                  icon="chevronRight"
                  iconPosition="right"
                  onClick={onNext}
                  disabled={disableNext}
                >
                  <FooterLabel long={W.NAV_NEXT} short={W.NAV_NEXT_SHORT} />
                </ClinicalButton>
              ) : null}

              <span className="nr-passage-footer__divider" aria-hidden />

              <ClinicalButton
                className={FOOTER_BTN}
                variant="secondary"
                size="md"
                icon="arrowRight"
                disabled={busyAction}
                onClick={onTransfer}
              >
                <FooterLabel long={W.FOOTER_TRANSFER} short={W.FOOTER_TRANSFER_SHORT} />
              </ClinicalButton>

              <ClinicalButton
                className={`${FOOTER_BTN} nr-passage-footer__btn--primary`}
                variant="primary"
                size="md"
                icon="checkCircle"
                disabled={busyAction}
                onClick={onClose}
              >
                <FooterLabel long={W.FOOTER_CLOSE} short={W.FOOTER_CLOSE_SHORT} />
              </ClinicalButton>
            </div>
        )}
      </div>
    </footer>
  );
}
